import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
/**
  * This component displays the patient information. This component can be invoked from the dashboard module, and the same component is also invoked from the patient list. This reusability ensures consistency of information. The source of information is backend services, which in turn pull the data from FHIR dataset, and some information like “activity” is pulled from Firestore for real-time updates.
*/
@Component({
  selector: 'app-task-detail-popup',
  templateUrl: './task-detail-popup.component.html',
  styleUrls: ['./task-detail-popup.component.scss']
})
export class TaskDetailPopupComponent {
  popupData = {
    patientId: null
  };

  constructor(public dialogRef: MatDialogRef<TaskDetailPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public popup) { 
      this.popupData = popup;
    }

  closePopup(event){
    if(event)
      this.dialogRef.close();
  }
}
